<template>
    <!-- <sa-page-layout :showModalLoading="showModalLoading" :btnEditVisible="isThisFirmato" :btnAnnullaVisible="false"
        :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :data="jsonData"
        class="sa-no-space">
        <template slot="toolbar">
        </template>
        <template slot="toolbar-title">
            <paziente-anagrafica :linkPatient="linkPatient" :idPaziente="idPaziente"></paziente-anagrafica>
        </template>
        <template slot="table-header">
            <h3 class="sa-event-title">Emergenza</h3>
        </template>
        <template slot="table-body">
            <div class="sa-tab-scroll">
                <emergenza-view-component :idEvento="id"></emergenza-view-component>
            </div>
        </template>
    </sa-page-layout> -->
    <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :pathResourceFirma="pathResourceFirma" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData">
        <template slot="tab-content-event">
            <emergenza-view-component :idEvento="id" @update="onUpdateJsonData"></emergenza-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import UtilityMixins from "../../../../../utility/UtilityMixin";
import EmergenzaViewComponent from "./EmergenzaViewComponent.vue";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixins from "../../../utility/mixins/EventiMixins";

export default {
    mixins: [UtilityMixins, EventiMixins],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { EmergenzaViewComponent, EventiViewComponent },
    data() {
        return {
            titoloEvento: "Emergenza",
            linkback: null,
            pathResource: "/cardioemergenze",
            pathResourceFirma: "/cardioemergenze",
            id: null,
            linkPrintData: null,
            jsonData: {},
            showModalLoading: false,
            fontScale: 2,
            linkedit: null,
            pathRestValidation: "/validation",
            isThisFirmato: false,
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixins.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        let me = this;
        me.jsonData.idPaziente = this.$route.query.idPaziente;
        me.id = this.$route.params.id;
    },
    methods: {
        updateStatoFirma(firmato) {
            console.log(firmato);
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
        },
    },
};
</script>
